var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('loading',{attrs:{"active":_vm.showUniversalLoader,"can-cancel":true,"is-full-page":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }